import { create } from 'zustand';
import appConfig from '../config/appConfig';

export const useSiteConfigStore = create((set, get) => ({
  config: null,
  loaded: false,

  fetchConfig: async () => {
    try {
      const baseUrl = appConfig.getApiUrl();
      const res = await fetch(`${baseUrl}/settings/site-config`);
      const json = await res.json();
      if (json.success) {
        set({ config: json.data, loaded: true });
        get().applyConfig(json.data);
      }
    } catch (error) {
      console.error('Failed to load site config:', error);
      set({ loaded: true });
    }
  },

  applyConfig: (cfg) => {
    if (!cfg) return;

    // Apply CSS custom properties for colors
    const root = document.documentElement;
    if (cfg.primary_color) {
      root.style.setProperty('--site-primary', cfg.primary_color);
      // Generate lighter/darker variants
      root.style.setProperty('--site-primary-light', cfg.primary_color + '20');
    }
    if (cfg.secondary_color) {
      root.style.setProperty('--site-secondary', cfg.secondary_color);
    }
    if (cfg.sidebar_bg_color) {
      root.style.setProperty('--site-sidebar-bg', cfg.sidebar_bg_color);
    }
    if (cfg.sidebar_text_color) {
      root.style.setProperty('--site-sidebar-text', cfg.sidebar_text_color);
    }
    if (cfg.header_bg_color) {
      root.style.setProperty('--site-header-bg', cfg.header_bg_color);
    }
    if (cfg.header_text_color) {
      root.style.setProperty('--site-header-text', cfg.header_text_color);
    }
    if (cfg.login_bg_color) {
      root.style.setProperty('--site-login-bg', cfg.login_bg_color);
    }

    // Apply document title
    if (cfg.site_name) {
      document.title = cfg.site_name;
    }

    // Apply favicon
    if (cfg.favicon_url) {
      const faviconUrl = appConfig.getBaseUrl() + cfg.favicon_url;
      let link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.href = faviconUrl;
      } else {
        link = document.createElement('link');
        link.rel = 'icon';
        link.href = faviconUrl;
        document.head.appendChild(link);
      }
    }
  },
}));
